<template>
  <SelectPopover
    button-color="grey"
    :modelValue="selectedOption.value"
    :label="label"
    :options="options"
    @update:modelValue="(value) => $emit('select', value)"
    @show="open = true"
    @hide="open = false"
  >
    <template #button-content>
      <span>
        {{ selectedOption.label }}
      </span>
      <ChevronUpIcon16 v-if="open" />
      <ChevronDownIcon16 v-else />
    </template>
  </SelectPopover>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ChevronDownIcon16 from '@components/Icons/ChevronDownIcon16.vue';
import ChevronUpIcon16 from '@components/Icons/ChevronUpIcon16.vue';

export default defineComponent({
  name: 'Selector',

  emits: { select: null },

  components: {
    ChevronDownIcon16,
    ChevronUpIcon16,
  },

  props: {
    selectedOption: {
      type: Object,
      required: true,
    },

    options: {
      type: Array,
      required: true,
    },

    label: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      open: false,
    };
  },
});
</script>

<style lang="scss">
.selector__button {
  width: 100%;
}
</style>
